<template>
  <div>
    <v-snackbar
      v-model="showNotification"
      :timeout="timeout"
      :top="y === 'top'"
      dark
      :color="color"
    >
      {{ notificationMsg }}
    </v-snackbar>
    <v-form
      class="px-3"
      ref="form"
      @submit.prevent="submit"
      v-if="!showMailVerification"
    >
      <v-card flat outlined width="450" class="mx-auto mt-9">
        <v-progress-linear
          class="mt-n1"
          indeterminate
          color="primary"
          v-if="loading"
        ></v-progress-linear>
        <div class="pa-4 pb-0 text-center">
          <div class="d-flex justify-center align-items-center mt-6">
            <!-- <v-img :src="require('@/assets/logo_org.png')" max-width="120"> -->
            <v-img :src="require('@/assets/image/Solva_Logo.svg')" max-width="170">
            
            </v-img>
          </div>
          <v-card-title class="justify-center text-h5 mb-4"
            >Log in to your account</v-card-title
          >
          <v-card-text>
            <v-text-field
              v-model="username"
              label="Email address"
              prepend-icon="mdi-account-circle"
              :rules="inputRules"
            />
            <v-text-field
              v-model="password"
              label="Password"
              :type="showpassword ? 'text' : 'password'"
              prepend-icon="mdi-lock"
              :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showpassword = !showpassword"
              :rules="inputRules"
            />
          </v-card-text>
          <v-card-text class="d-flex justify-space-between align-center pt-2 mb-8">
            <v-btn
              text
              router
              :to="'/reset-pwd'"
              color="grey darken-2"
              class="text-none text-decoration-underline"
              >Forgot password?</v-btn
            >

            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
              depressed
              style="width: 96px"
              >Login</v-btn
            >
          </v-card-text>

          <v-divider ></v-divider>
          <v-card-actions class="pa-4 justify-center align-center">
            <div
              class="text-body-1 font-weight-regular ml-4 mr-1"
              style="padding-top: 2px"
            >
              New to Solva?
            </div>

            <v-btn
              text
              color="primary"
              router
              :to="'/registration'"
              class="text-capitalize"
              style="font-size: 1rem"
              >Create account</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-form>
    <v-form
      class="px-3"
      ref="form2"
      @submit.prevent="verifyEmail"
      v-if="showMailVerification"
    >
      <v-card flat outlined width="500" class="mx-auto my-10">
        <v-progress-linear
          class="mt-n1"
          indeterminate
          color="primary"
          v-if="loading"
        ></v-progress-linear>
        <div class="px-4">
          <div class="d-flex justify-center align-items-center mt-6">
            <v-img :src="require('@/assets/logo_org.png')" max-width="120">
            </v-img>
          </div>
          <div>
            <v-card-title class="justify-center text-center pt-6 pb-8 text-5"
              >Email Verification is pending</v-card-title
            >
          </div>
          <v-card-text class="text-body-1"
            >An 8 digit verification code has been sent to your email address.
            <br /><br />Please enter the code below
          </v-card-text>
          <v-card-text class="text-center pt-0">
            <div class="d-flex align-items-center justify-center">
              <v-text-field
                v-model="verificationCode"
                type="text"
                prepend-icon="mdi-key-variant"
                required
                :rules="[
                  verificationCodeRules.exactlength,
                  verificationCodeRules.required,
                ]"
                style="max-width: 300px"
              >
                <template v-slot:label>
                  Verification Code
                  <span class="red--text">*</span>
                </template>
              </v-text-field>
            </div>
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
              class="text-capitalize mt-6"
            >
              Submit
            </v-btn>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="subtitle"
            >Note: Please check your spam folder in case the email does not
            appear in your inbox.</v-card-text
          >
        </div>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import authService from "@/services/auth";
import registrationService from "@/libs/registrationService.js";

export default {
  name: "Login",
  data() {
    return {
      showMailVerification: false,
      showpassword: false,
      username: "",
      password: "",
      notificationMsg: "",
      inputRules: [(v) => !!v || "This field is required"],
      verificationCodeRules: {
        exactlength: (v) => (v && v.length === 8) || "Invalid code",
        required: (v) => !!v || "This field is required",
      },
      showNotification: false,
      timeout: 5000,
      y: "top",
      color: "orange",
      loading: false,
    };
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const res = await authService.login(this.username, this.password);
        if (res !== null) {
          if (res.data.emailVerificationRequired === true) {
            this.showMailVerification = true;
          } else {
            if (this.$router.history && this.$router.history.current) {
              const { query } = this.$router.history.current;
              if (query && query.redirect) {
                window.location.href = query.redirect;
              } else {
                window.location.href = "/dashboard";
              }
            } else {
              window.location.href = "/dashboard";
            }
          }
        } else {
          this.showNotification = true;
          this.notificationMsg = "Invalid Email or Password";
        }
        this.loading = false;
      }
    },
    verifyEmail() {
      if (this.$refs.form2.validate()) {
        const payload = {
          email: this.username,
          code: this.verificationCode,
        };
        this.loading = true;
        registrationService
          .verifyEmail(payload)
          .then((res) => {
            if (res.data && res.data.success === true && res.data.message) {
              this.color = "green";
              this.notificationMsg = res.data.message;
              this.showNotification = true;
            }
            this.$refs.form2.reset();
            this.showMailVerification = false;
            setTimeout(() => {
              this.showNotification = false;
              this.password = "";
              this.notificationMsg = "Please login again...";
              this.showNotification = true;
              this.loading = false;
              setTimeout(() => {
                this.$router.push({ name: "Login" });
              }, 4000);
            }, 2000);
          })
          .catch((error) => {
            this.color = "red";
            this.notificationMsg =
              "An error occured while verifying your email address";
            if (error.response) {
              const { data } = error.response;
              if (data.message) {
                this.notificationMsg = data.message;
              }
            }
            this.showNotification = true;
            this.loading = false;
          });
      }
    },
  },
};
</script>
